import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  // Validador para el número de vuelo
  static flightNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const pattern = /(([A-Za-z]{2}|[A-Za-z]\d|\d[A-Za-z])([1-9]|\s)(\d{1,4})|(((\W|^)FFAA(\W|$))|((\W|^)GOB(\W|$))|((\W|^)PRIV(\W|$))|((\W|^)SANI(\W|$))|((\W|^)ffaa(\W|$))|((\W|^)gob(\W|$))|((\W|^)priv(\W|$))|((\W|^)sani(\W|$))|((\W|^)YPF(\W|$))|((\W|^)ypf(\W|$))))/;

    if (!control.value || pattern.test(control.value)) {
      return null;
    } else {
      return { flightNumber: true };
    }
  };

  // Validador para números enteros positivos
  static positiveIntegerValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const pattern = /^[1-9]\d*$/;

    if (!control.value || pattern.test(control.value)) {
      return null;
    } else {
      return { positiveInteger: true };
    }
  };

  // Validador para correos electrónicos válidos
  static emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!control.value || pattern.test(control.value)) {
      return null;
    } else {
      return { email: true };
    }
  };

  //Validador para número de rancho
  static numeroRanchoValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const pattern = new RegExp('^[a-zA-Z0-9]{16}$');

    if (!control.value || pattern.test(control.value)) {
      return null;
    } else {
      return { numeroRancho: true };
    }
  }
}
